import { Card } from 'antd';
import { CardCProps } from 'src/interface/Layout/Card';

import classes from './index.module.css';
import cn from "src/utils/cn";

const CardC = (props: CardCProps) => {
	const { className, sticky, children, ...cardProps } = props;
	return (
		<Card
			{...cardProps}
			className={cn(classes.card, className, { [classes.sticky]: sticky })}
		>
			{children}
		</Card>
	);
};

export default CardC;
